export default __webpack_public_path__ + "locales/uk-UA/PaymentsEnterprise.json?hash=4d94b35a682d3d4f6681470911285c88";